import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "440",
  "slug": "busiest-airports-in-the-world",
  "title": "The Busiest Airports in 2025, by Different Measures",
  "excerpt": "Atlanta led total passengers, Dubai international passengers, and Hong Kong cargo.",
  "date": "2026-06-14",
  "category": "Geography",
  "image": "https://images.unsplash.com/photo-1683971336619-d445cbec0276?ixid=M3w5NjY4NzN8MHwxfHNlYXJjaHwxfHxhaXJwb3J0JTIwcnVud2F5JTIwYWVyaWFsfGVufDF8MHx8fDE3ODE0MjUwODF8MA&ixlib=rb-4.1.0&w=800&q=80&fit=crop",
  "readTime": "2 min",
  "author": "EarthGuessr Team",
  "content": [
    {
      "type": "paragraph",
      "text": "Atlanta was the busiest airport by total passenger traffic in ACI World's published 2025 figures, with about 106.3 million passengers. Dubai followed with 95.2 million and Tokyo Haneda with 91.7 million. Dallas/Fort Worth was fourth with 85.7 million."
    },
    {
      "type": "paragraph",
      "text": "These figures refer to 2025 traffic, checked against ACI's table on 14 September 2026. Annual rankings can be revised; use the linked table when you need the latest release."
    },
    {
      "type": "heading",
      "text": "Passengers, cargo, and flights give different answers"
    },
    {
      "type": "list",
      "items": [
        "Total passengers: Atlanta led the 2025 table.",
        "International passengers: Dubai led, followed by London Heathrow and Incheon.",
        "Cargo tonnage: Hong Kong led, followed by Shanghai Pudong and Anchorage.",
        "Aircraft movements: Chicago O'Hare led. This counts takeoffs and landings rather than the people or freight aboard."
      ]
    },
    {
      "type": "paragraph",
      "text": "An airport can serve a large connecting network without being in the world's most populous city. Passenger traffic is also not a count of unique individuals: a traveller can pass through an airport more than once."
    },
    {
      "type": "heading",
      "text": "What the layout tells you"
    },
    {
      "type": "paragraph",
      "text": "On a satellite image, look for runways, parallel taxiways, aprons, and terminal buildings. Those features can identify an airport, but its footprint does not establish its traffic ranking. A large site can include room for expansion, and a compact site can handle many passengers."
    },
    {
      "type": "paragraph",
      "text": "Compare two airports at the same map scale. Count the runways and identify their approaches, then check the traffic data separately. Keeping those observations apart prevents a large patch of concrete from becoming an unsupported claim about passenger numbers."
    }
  ],
  "sources": [
    {
      "title": "ACI World: 2025 airport traffic tables",
      "url": "https://aci.aero/resources/busiest-airports-in-the-world/"
    }
  ],
  "relatedSlugs": [
    "how-to-spot-an-airport-from-satellite-imagery"
  ]
};
